import React from 'react'
import { Label as ReactstrapLabel, LabelProps } from 'reactstrap'

export const Label: React.FC<LabelProps> = props => {
  return <ReactstrapLabel {...props} />
}
